export default __webpack_public_path__ + "static/media/StephenChen.34bf88a9.jpg";